export default {_name:'icon',module:'Field',view:'Element/Icon',options:{xs:12}}